export default __webpack_public_path__ + "static/media/bg.31d11c37.png";